module.exports = __webpack_public_path__ + "img/L.d2c442a2.webp";